<div class="ppl-container-body">
  <div class="ppl-container">
    <div class="ppl-content-container" style="padding: 8px; max-height: calc(100vh - 140px); box-sizing: border-box;">
      <div class="line1">
        <div class="action">
          <ppl-button [label]="'Back'" icon="fa fa-chevron-left" (click)="goBack()"
            [customClass]="'primary-button semi-rounded'" [iconPosition]="'left'"></ppl-button>
        </div>
      </div>
      <div class="line2">
        {{pageTitle}}
      </div>
      <div style="width: 100%">
        <ppl-accordion [title]="'Basic Information'" [isOpen]="true">
          <div class="wiz-body">
            <div class="ppl-mt24" style="width: 100%">
              <div class="custom-row">
                @if(mode==="edit" && !this.isNew){
                <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
                  (click)="onCancel()"></ppl-button>
                <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
                  (click)="onAdd('update')"></ppl-button>
                }
                @if(mode==="read" && !this.isNew){
                <ppl-button label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="onEdit()" style="margin-right: 8px;"></ppl-button>
                <ppl-button label="Delete" icon="fa fa-trash" [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="onDelete()"></ppl-button>
                }
              </div>
              @if(mode==="edit"){
              <form nz-form nz-row [formGroup]="configForm" class="ppl-p0">
                @if(isAttrAvailable('module')){
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                  <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="module"
                      class="ppl-form-label">{{getAttributes('module').label}}
                      @if(getAttributes('module').mandatory === 'Y'){
                      <span [attr.aria-label]="'Required'">*</span>
                      }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="getAttributes('module')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['module'] }">
                          <ppl-dropdown-select formControlName="module" class="ppl-select" id="module"
                            [options]="moduleList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                            placeholder="{{getAttributes('module').placeholder}}" />
                        </div>
                      </div>
                      @if (validationErrors['module']) {
                      <span class="pl-1 error-message">{{validationErrors['module']}}</span>
                      }
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
                }
                @if(isAttrAvailable('category')){
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                  <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="category"
                      class="ppl-form-label">{{getAttributes('category').label}}
                      @if(getAttributes('category').mandatory === 'Y'){
                      <span [attr.aria-label]="'Required'">*</span>
                      }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="getAttributes('category')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['category'] }">
                          <ppl-dropdown-select formControlName="category" class="ppl-select" id="category"
                            [options]="categoryList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                            placeholder="{{getAttributes('category').placeholder}}" />
                        </div>
                      </div>
                      @if (validationErrors['category']) {
                      <span class="pl-1 error-message">{{validationErrors['category']}}</span>
                      }
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
                }
                @if(isAttrAvailable('subCategory')){
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                  <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="subCategory"
                      class="ppl-form-label">{{getAttributes('subCategory').label}}
                      @if(getAttributes('subCategory').mandatory === 'Y'){
                      <span [attr.aria-label]="'Required'">*</span>
                      }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="getAttributes('subCategory')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="subCategory" id="subCategory"
                          placeholder="{{getAttributes('subCategory').placeholder}}"
                          [ngClass]="{'error': validationErrors['subCategory'] }" />
                      </div>
                      @if (validationErrors['subCategory']) {
                      <span class="pl-1 error-message">{{validationErrors['subCategory']}}</span>
                      }
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
                }
                @if(isAttrAvailable('orgType')){
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                  <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="orgType"
                      class="ppl-form-label">{{getAttributes('orgType').label}}
                      @if(getAttributes('orgType').mandatory === 'Y'){
                      <span [attr.aria-label]="'Required'">*</span>
                      }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="getAttributes('orgType')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['orgType'] }">
                          <ppl-dropdown-select formControlName="orgType" class="ppl-select" id="orgType"
                            [options]="orgTypeList" [optionLabel]="'orgtypeLpk'" [optionValue]="'orgtypeLpk'"
                            placeholder="{{getAttributes('orgType').placeholder}}" />
                        </div>
                      </div>
                      @if (validationErrors['orgType']) {
                      <span class="pl-1 error-message">{{validationErrors['orgType']}}</span>
                      }
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
                }

                @if(isAttrAvailable('orgName')){
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                  <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="orgName"
                      class="ppl-form-label">{{getAttributes('orgName').label}}
                      @if(getAttributes('orgName').mandatory === 'Y'){
                      <span [attr.aria-label]="'Required'">*</span>
                      }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="getAttributes('orgName')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['orgName'] }">
                          <ppl-dropdown-select formControlName="orgName" class="ppl-select" id="orgName"
                            [options]="orgNameList" [optionLabel]="'orgName'" [optionValue]="'orgName'"
                            placeholder="{{getAttributes('orgName').placeholder}}" />
                        </div>
                      </div>
                      @if (validationErrors['orgName']) {
                      <span class="pl-1 error-message">{{validationErrors['orgName']}}</span>
                      }
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
                }
                @if(isAttrAvailable('configKey')){
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                  <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="configKey"
                      class="ppl-form-label">{{getAttributes('configKey').label}}
                      @if(getAttributes('configKey').mandatory === 'Y'){
                      <span [attr.aria-label]="'Required'">*</span>
                      }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="getAttributes('configKey')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="configKey" id="configKey"
                          placeholder="{{getAttributes('configKey').placeholder}}"
                          [ngClass]="{'error': validationErrors['configKey'] }" />
                      </div>
                      @if (validationErrors['configKey']) {
                      <span class="pl-1 error-message">{{validationErrors['configKey']}}</span>
                      }
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
                }

                @if(isAttrAvailable('configValue')){
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                  <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="configValue"
                      class="ppl-form-label">{{getAttributes('configValue').label}}
                      @if(getAttributes('configValue').mandatory === 'Y'){
                      <span [attr.aria-label]="'Required'">*</span>
                      }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="getAttributes('configValue')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="configValue" id="configValue"
                          placeholder="{{getAttributes('configValue').placeholder}}"
                          [ngClass]="{'error': validationErrors['configValue'] }" />
                      </div>
                      @if (validationErrors['configValue']) {
                      <span class="pl-1 error-message">{{validationErrors['configValue']}}</span>
                      }
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
                }

                @if(isAttrAvailable('configDesc')){
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                  <nz-row>
                    <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="configDesc"
                      class="ppl-form-label">{{getAttributes('configDesc').label}}
                      @if(getAttributes('configDesc').mandatory === 'Y'){
                      <span [attr.aria-label]="'Required'">*</span>
                      }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="getAttributes('configDesc')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <textarea rows="3" nz-input formControlName="configDesc" id="configDesc"
                          [ngClass]="{'error': validationErrors['configDesc'] }"
                          placeholder="{{getAttributes('configDesc').placeholder}}"></textarea>
                      </div>
                      @if (validationErrors['configDesc']) {
                      <span class="pl-1 error-message">{{validationErrors['configDesc']}}</span>
                      }
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
                }
              </form>
              @if(isNew){
              <div class="custom-row">
                <ppl-button [label]="'Cancel'" [icon]="'fa fa-close'" style="margin-right:4px; font-size:0.857rem;"
                  [customClass]="'ghost-button'" [iconPosition]="'right'" (click)="goBack()"></ppl-button>
                <ppl-button label="Submit" icon="fa fa-check-circle" [customClass]="'primary-button'"
                  [iconPosition]="'right'" (click)="onAdd('add')"></ppl-button>
              </div>
              }
              }
              @else if (mode==="read") {
              <div nz-row>
                @if(isAttrAvailable('module')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("module").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.module }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('category')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("category").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.category }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('subCategory')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("subCategory").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.subCategory }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('orgType')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("orgType").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2 read-text">{{ savedData?.orgType }}</div>
                  </div>
                </div>
                } @if(isAttrAvailable('orgName')){

                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("orgName").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2 read-text">{{ savedData?.orgName }}</div>
                  </div>
                </div>

                } @if(isAttrAvailable('configKey')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("configKey").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2 read-text">{{ savedData?.configKey }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('configValue')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("configValue").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2 read-text">{{ savedData?.configValue }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('configDesc')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("configDesc").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.configDesc }}</div>
                  </div>
                </div>
                }
              </div>
              }
            </div>
          </div>
        </ppl-accordion>
      </div>
    </div>
  </div>
</div>
<div class="filter-panel">
  <ng-template #confirmationDialog let-cancel="cancel">
    <p> Are you sure you want to delete this config ?</p>
  </ng-template>
</div>